module.exports = __webpack_public_path__ + "img/home-banner.87479a0.png";